import React from 'react';
import './GlobalLoading.css';

function GlobalLoading() {
  return (
    <div id="global-loading" className="global-loading">
      <div className="loading-content">
        <div className="spinner"></div>
        <div className="loading-text">加载中...</div>
      </div>
    </div>
  );
}

export default GlobalLoading;

